import React, { useEffect, useState } from "react";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import Loader from "../../components/Loader";
import { ROLES } from "../../constants/UserRoles";
import SingleBulkDetails from "../../components/orgAdmin/students/batches/bulkUpload/SingleBulkDetails";
import { useParams, useSearchParams } from "react-router-dom";

function OrgAdminBulkDetails() {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);

  const batchIdentifier = searchParams.get("batchIdentifier");
  const bulkId = searchParams.get("bulkId");

  return (
    <>
      {loading && <Loader />}
      <div className="hirePlusPlusPageContent">
        <Sidebar activePage="students" userRole={ROLES.org_admin} />
        <div className="w-full hireplusplusRightContent">
          <Topbar
            activePage="students"
            userRole={ROLES.org_admin}
            newTitle="Individual Bulk"
            noNavigate={false}
          />
          <SingleBulkDetails
            setLoading={setLoading}
            batchIdentifier={batchIdentifier}
            bulkId={bulkId}
          />
        </div>
      </div>
    </>
  );
}

export default OrgAdminBulkDetails;
